import camelcaseKeys from "camelcase-keys";
import api from "./api";

export function getLive(guid) {
  return api
    .get(`/live/${guid}`)
    .then((res) => camelcaseKeys(res.data, { deep: true }));
}
